export enum CheckoutConditions {
  HAS_HARD_CONFLICTS = 'HAS_HARD_CONFLICTS',
  MINIMUM_SPEND_NOT_MET = 'MINIMUM_SPEND_NOT_MET',
}
